const isDesktopSSR = (userAgent) => {
    if (!userAgent) {
        return true;
    }

    const normalizedUserAgent = userAgent.toLowerCase();
    const mobileRegex = /phone|android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;
    const isMobile = mobileRegex.test(normalizedUserAgent);

    return !isMobile;
};

export default isDesktopSSR;
